<!-- Row Per Page: {{backEnd.rowPerPage}} ::-->
{{(backEnd.currentPage * backEnd.rowPerPage)+1}} -
<span *ngIf="((backEnd.currentPage * backEnd.rowPerPage)+backEnd.rowPerPage)<backEnd.totalCount">{{(backEnd.currentPage
  *
  backEnd.rowPerPage)+backEnd.rowPerPage}}</span>
<span
  *ngIf="((backEnd.currentPage * backEnd.rowPerPage)+backEnd.rowPerPage)>=backEnd.totalCount">{{backEnd.totalCount}}</span>
of {{backEnd.totalCount}}

<button [disabled]="backEnd.currentPage==0" class="margin10px font2 bold" style="padding: 2px 5px; margin: 2px 5px;"
  (click)="backEnd.currentPage=backEnd.currentPage-1; newData.emit();">
  < </button>
    <span *ngFor="let page of backEnd.pageArray">
      <ion-badge *ngIf="page!=0" [color]="page==(backEnd.currentPage+1)?'primary':'light'"
        (click)="backEnd.currentPage=page-1; newData.emit();" mode="ios">{{page}}</ion-badge>
      <span *ngIf="page==0">...</span>
    </span>
    <button [disabled]="backEnd.totalCount/backEnd.rowPerPage <= (backEnd.currentPage+1)" class="font2 bold margin10px"
      style="padding: 2px 5px; margin: 2px 5px;"
      (click)="backEnd.currentPage=backEnd.currentPage+1; newData.emit();">></button>